import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service';
import { MasterParkingRates } from '../Models/master-parking-rates';
import { MasterProfile } from '../Models/master-profile';
import { Status } from '../Models/status';

@Injectable({
  providedIn: 'root'
})
export class RatesService {

  private BaseApiPath:string;
  constructor(private http:HttpClient,private coreService:CoreServiceService) { 

    this.BaseApiPath=this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;

  }
  public getRates():Observable<MasterParkingRates[]>{
    const ApiUrl=this.BaseApiPath+'rates/getrates';
      return this.http.get<MasterParkingRates[]>(ApiUrl);
  }
  public GetRate(masterParkingRate:MasterParkingRates):Observable<MasterParkingRates>{
    const ApiUrl=this.BaseApiPath+'rates/GetRate';
      return this.http.post<MasterParkingRates>(ApiUrl,masterParkingRate);
  }
  public InsertUpdateRate(masterParkingRate:MasterParkingRates):Observable<Status<string>>{
    const ApiUrl=this.BaseApiPath+'rates/InsertUpdateRate';
      return this.http.post<Status<string>>(ApiUrl,masterParkingRate);
  }
  public GetProfiles():Observable<MasterProfile[]>{
    const ApiUrl = this.BaseApiPath +'rates/GetProfiles';
      return this.http.get<MasterProfile[]>(ApiUrl);
  }
  public GetOtherProfiles():Observable<MasterProfile[]>{
    const ApiUrl=this.BaseApiPath+'rates/getotherprofiles';
      return this.http.get<MasterProfile[]>(ApiUrl);
  }
  public GetProfile(masterProfile:MasterProfile):Observable<MasterProfile>{
    const ApiUrl=this.BaseApiPath+'rates/getprofile';
      return this.http.post<MasterProfile>(ApiUrl,masterProfile);
  }
  public InsertUpdateProfile(masterProfile:MasterProfile):Observable<Status<string>>{
    const ApiUrl=this.BaseApiPath+'rates/InsertUpdateProfile';
      return this.http.post<Status<string>>(ApiUrl,masterProfile);
  }
}
